import { render, staticRenderFns } from "./MultiCheckBox.vue?vue&type=template&id=16571644"
import script from "./MultiCheckBox.vue?vue&type=script&lang=js"
export * from "./MultiCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports